import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { fmtDT } from "@/lib/format";

export const TakeoverCard = ({ type, targetId, closed }) => {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [note, setNote] = useState("");
  const isCeo = user.role === "ceo";
  const load = useCallback(() => {
    if (isCeo) api.get("/toth/takeovers", { params: { target_id: targetId } }).then((r) => setRows(r.data));
  }, [isCeo, targetId]);
  useEffect(() => {
    load();
  }, [load]);
  if (!isCeo) return null;
  const active = rows.find((r) => r.status === "attiva");
  const call = async (fn) => {
    try {
      await fn();
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const start = () => call(() => api.post("/toth/takeovers", { target_type: type, target_id: targetId, note }).then(() => toast.success("Toth segue la pratica")));
  const stop = () => call(() => api.post(`/toth/takeovers/${active.id}/stop`));
  const last = active || rows[0];
  return (
    <section className="card-soft p-5" data-testid="takeover-card">
      <h3 className="mb-2 flex items-center gap-2 font-bold"><Sparkles className="h-4 w-4 text-primary" />Toth prendi in carico</h3>
      {active ? (
        <p className="text-sm" data-testid="takeover-status">Toth segue questa pratica dal {fmtDT(active.started_at)}: sollecita secondo le politiche, poi porta al responsabile e al CEO. Si ferma alla chiusura.</p>
      ) : !closed && (
        <div className="flex flex-col gap-2">
          <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Indicazioni per Toth (facoltative)" className="rounded-xl" data-testid="takeover-note" />
          <Button onClick={start} className="rounded-xl" data-testid="takeover-start">Affida a Toth</Button>
        </div>
      )}
      {active && <Button variant="outline" onClick={stop} className="mt-3 rounded-xl" data-testid="takeover-stop">Interrompi</Button>}
      {last && (
        <div className="mt-3 max-h-48 space-y-1 overflow-y-auto rounded-xl bg-muted p-3 text-xs" data-testid="takeover-history">
          {[...last.history].reverse().map((h, i) => <p key={i}><b>{fmtDT(h.at)}</b> · {h.text}</p>)}
        </div>
      )}
    </section>
  );
};
